module.exports = "/images/location.svg?31c926efe5cd3b9741c5cd0a9f493b8d";